/**
 * @generated SignedSource<<bd7d3367a410a1f5256dd5f4e3ecd502>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
import { FragmentRefs } from "relay-runtime";
export type KPIItemTeamInProgress_RoutineOccasion$data = {
  readonly id: string;
  readonly occasionSections: ReadonlyArray<{
    readonly taskExecutions: ReadonlyArray<{
      readonly formattedNumberValue?: string | null;
      readonly isCompleted?: boolean;
      readonly numberValue?: number | null;
      readonly task?: {
        readonly unit: NumberTaskUnit;
      };
    }>;
  }>;
  readonly startAt: string;
  readonly " $fragmentType": "KPIItemTeamInProgress_RoutineOccasion";
};
export type KPIItemTeamInProgress_RoutineOccasion$key = {
  readonly " $data"?: KPIItemTeamInProgress_RoutineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIItemTeamInProgress_RoutineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "teamId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPIItemTeamInProgress_RoutineOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "teamId",
          "variableName": "teamId"
        }
      ],
      "concreteType": "RoutineOccasionSection",
      "kind": "LinkedField",
      "name": "occasionSections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "taskExecutions",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "formattedNumberValue",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "numberValue",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isCompleted",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TaskNumber",
                  "kind": "LinkedField",
                  "name": "task",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "unit",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "TaskExecutionNumber",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};

(node as any).hash = "a46a38345e72a415a1c0e54fb3781733";

export default node;
